import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CreateReview201,
  CreateReview400,
  CreateReview403,
  CreateReview404,
  CreateReview409,
  CreateReviewBody,
  DeleteReview403,
  DeleteReview404,
  GetCourseReviewStats200,
  GetCourseReviewStats404,
  GetCourseReviews200,
  GetCourseReviews404,
  GetCourseReviewsParams,
  GetReview200,
  GetReview404,
  UpdateReview200,
  UpdateReview400,
  UpdateReview403,
  UpdateReview404,
  UpdateReviewBody,
  VoteReview200,
  VoteReview400,
  VoteReview404,
  VoteReviewBody
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * 특정 코스의 리뷰 목록을 페이지네이션하여 조회합니다
 * @summary 코스 리뷰 목록 조회
 */
export const getCourseReviews = (
    courseId: string,
    params?: GetCourseReviewsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCourseReviews200>(
      {url: `/api/courses/${courseId}/reviews`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetCourseReviewsQueryKey = (courseId: string,
    params?: GetCourseReviewsParams,) => {
    return [`/api/courses/${courseId}/reviews`, ...(params ? [params]: [])] as const;
    }

    
export const getGetCourseReviewsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getCourseReviews>>, TError = GetCourseReviews404>(courseId: string,
    params?: GetCourseReviewsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseReviews>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseReviewsQueryKey(courseId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseReviews>>> = ({ signal }) => getCourseReviews(courseId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(courseId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseReviews>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseReviewsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseReviews>>>
export type GetCourseReviewsInfiniteQueryError = GetCourseReviews404

/**
 * @summary 코스 리뷰 목록 조회
 */
export const useGetCourseReviewsInfinite = <TData = Awaited<ReturnType<typeof getCourseReviews>>, TError = GetCourseReviews404>(
 courseId: string,
    params?: GetCourseReviewsParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseReviews>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseReviewsInfiniteQueryOptions(courseId,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCourseReviewsQueryOptions = <TData = Awaited<ReturnType<typeof getCourseReviews>>, TError = GetCourseReviews404>(courseId: string,
    params?: GetCourseReviewsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseReviews>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseReviewsQueryKey(courseId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseReviews>>> = ({ signal }) => getCourseReviews(courseId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(courseId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourseReviews>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseReviewsQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseReviews>>>
export type GetCourseReviewsQueryError = GetCourseReviews404

/**
 * @summary 코스 리뷰 목록 조회
 */
export const useGetCourseReviews = <TData = Awaited<ReturnType<typeof getCourseReviews>>, TError = GetCourseReviews404>(
 courseId: string,
    params?: GetCourseReviewsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseReviews>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseReviewsQueryOptions(courseId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 수강생이 코스에 대한 리뷰를 작성합니다 (1인 1리뷰)
 * @summary 리뷰 작성
 */
export const createReview = (
    courseId: string,
    createReviewBody: CreateReviewBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CreateReview201>(
      {url: `/api/courses/${courseId}/reviews`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createReviewBody
    },
      options);
    }
  


export const getCreateReviewMutationOptions = <TError = CreateReview400 | CreateReview403 | CreateReview404 | CreateReview409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReview>>, TError,{courseId: string;data: CreateReviewBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createReview>>, TError,{courseId: string;data: CreateReviewBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createReview>>, {courseId: string;data: CreateReviewBody}> = (props) => {
          const {courseId,data} = props ?? {};

          return  createReview(courseId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateReviewMutationResult = NonNullable<Awaited<ReturnType<typeof createReview>>>
    export type CreateReviewMutationBody = CreateReviewBody
    export type CreateReviewMutationError = CreateReview400 | CreateReview403 | CreateReview404 | CreateReview409

    /**
 * @summary 리뷰 작성
 */
export const useCreateReview = <TError = CreateReview400 | CreateReview403 | CreateReview404 | CreateReview409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createReview>>, TError,{courseId: string;data: CreateReviewBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createReview>>,
        TError,
        {courseId: string;data: CreateReviewBody},
        TContext
      > => {

      const mutationOptions = getCreateReviewMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 코스의 리뷰 통계 (평균 평점, 평점 분포, 인기 태그)를 조회합니다
 * @summary 코스 리뷰 통계 조회
 */
export const getCourseReviewStats = (
    courseId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCourseReviewStats200>(
      {url: `/api/courses/${courseId}/reviews/stats`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCourseReviewStatsQueryKey = (courseId: string,) => {
    return [`/api/courses/${courseId}/reviews/stats`] as const;
    }

    
export const getGetCourseReviewStatsInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getCourseReviewStats>>, TError = GetCourseReviewStats404>(courseId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseReviewStats>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseReviewStatsQueryKey(courseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseReviewStats>>> = ({ signal }) => getCourseReviewStats(courseId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(courseId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseReviewStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseReviewStatsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseReviewStats>>>
export type GetCourseReviewStatsInfiniteQueryError = GetCourseReviewStats404

/**
 * @summary 코스 리뷰 통계 조회
 */
export const useGetCourseReviewStatsInfinite = <TData = Awaited<ReturnType<typeof getCourseReviewStats>>, TError = GetCourseReviewStats404>(
 courseId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCourseReviewStats>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseReviewStatsInfiniteQueryOptions(courseId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCourseReviewStatsQueryOptions = <TData = Awaited<ReturnType<typeof getCourseReviewStats>>, TError = GetCourseReviewStats404>(courseId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseReviewStats>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCourseReviewStatsQueryKey(courseId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourseReviewStats>>> = ({ signal }) => getCourseReviewStats(courseId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(courseId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCourseReviewStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetCourseReviewStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getCourseReviewStats>>>
export type GetCourseReviewStatsQueryError = GetCourseReviewStats404

/**
 * @summary 코스 리뷰 통계 조회
 */
export const useGetCourseReviewStats = <TData = Awaited<ReturnType<typeof getCourseReviewStats>>, TError = GetCourseReviewStats404>(
 courseId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCourseReviewStats>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetCourseReviewStatsQueryOptions(courseId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 특정 리뷰의 상세 정보를 조회합니다
 * @summary 리뷰 상세 조회
 */
export const getReview = (
    reviewId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetReview200>(
      {url: `/api/reviews/${reviewId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetReviewQueryKey = (reviewId: string,) => {
    return [`/api/reviews/${reviewId}`] as const;
    }

    
export const getGetReviewInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getReview>>, TError = GetReview404>(reviewId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReview>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReviewQueryKey(reviewId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReview>>> = ({ signal }) => getReview(reviewId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(reviewId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReviewInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getReview>>>
export type GetReviewInfiniteQueryError = GetReview404

/**
 * @summary 리뷰 상세 조회
 */
export const useGetReviewInfinite = <TData = Awaited<ReturnType<typeof getReview>>, TError = GetReview404>(
 reviewId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getReview>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetReviewInfiniteQueryOptions(reviewId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetReviewQueryOptions = <TData = Awaited<ReturnType<typeof getReview>>, TError = GetReview404>(reviewId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReview>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReviewQueryKey(reviewId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReview>>> = ({ signal }) => getReview(reviewId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(reviewId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReview>>, TError, TData> & { queryKey: QueryKey }
}

export type GetReviewQueryResult = NonNullable<Awaited<ReturnType<typeof getReview>>>
export type GetReviewQueryError = GetReview404

/**
 * @summary 리뷰 상세 조회
 */
export const useGetReview = <TData = Awaited<ReturnType<typeof getReview>>, TError = GetReview404>(
 reviewId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getReview>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetReviewQueryOptions(reviewId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * 작성한 리뷰를 수정합니다 (본인만 가능)
 * @summary 리뷰 수정
 */
export const updateReview = (
    reviewId: string,
    updateReviewBody: UpdateReviewBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<UpdateReview200>(
      {url: `/api/reviews/${reviewId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateReviewBody
    },
      options);
    }
  


export const getUpdateReviewMutationOptions = <TError = UpdateReview400 | UpdateReview403 | UpdateReview404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReview>>, TError,{reviewId: string;data: UpdateReviewBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateReview>>, TError,{reviewId: string;data: UpdateReviewBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateReview>>, {reviewId: string;data: UpdateReviewBody}> = (props) => {
          const {reviewId,data} = props ?? {};

          return  updateReview(reviewId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateReviewMutationResult = NonNullable<Awaited<ReturnType<typeof updateReview>>>
    export type UpdateReviewMutationBody = UpdateReviewBody
    export type UpdateReviewMutationError = UpdateReview400 | UpdateReview403 | UpdateReview404

    /**
 * @summary 리뷰 수정
 */
export const useUpdateReview = <TError = UpdateReview400 | UpdateReview403 | UpdateReview404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateReview>>, TError,{reviewId: string;data: UpdateReviewBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateReview>>,
        TError,
        {reviewId: string;data: UpdateReviewBody},
        TContext
      > => {

      const mutationOptions = getUpdateReviewMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 작성한 리뷰를 삭제합니다 (본인만 가능)
 * @summary 리뷰 삭제
 */
export const deleteReview = (
    reviewId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/reviews/${reviewId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteReviewMutationOptions = <TError = DeleteReview403 | DeleteReview404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReview>>, TError,{reviewId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteReview>>, TError,{reviewId: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteReview>>, {reviewId: string}> = (props) => {
          const {reviewId} = props ?? {};

          return  deleteReview(reviewId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteReviewMutationResult = NonNullable<Awaited<ReturnType<typeof deleteReview>>>
    
    export type DeleteReviewMutationError = DeleteReview403 | DeleteReview404

    /**
 * @summary 리뷰 삭제
 */
export const useDeleteReview = <TError = DeleteReview403 | DeleteReview404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteReview>>, TError,{reviewId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteReview>>,
        TError,
        {reviewId: string},
        TContext
      > => {

      const mutationOptions = getDeleteReviewMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * 리뷰에 대해 도움됨/도움안됨 투표를 합니다
 * @summary 리뷰 투표
 */
export const voteReview = (
    reviewId: string,
    voteReviewBody: VoteReviewBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<VoteReview200>(
      {url: `/api/reviews/${reviewId}/vote`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: voteReviewBody
    },
      options);
    }
  


export const getVoteReviewMutationOptions = <TError = VoteReview400 | VoteReview404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof voteReview>>, TError,{reviewId: string;data: VoteReviewBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof voteReview>>, TError,{reviewId: string;data: VoteReviewBody}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof voteReview>>, {reviewId: string;data: VoteReviewBody}> = (props) => {
          const {reviewId,data} = props ?? {};

          return  voteReview(reviewId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VoteReviewMutationResult = NonNullable<Awaited<ReturnType<typeof voteReview>>>
    export type VoteReviewMutationBody = VoteReviewBody
    export type VoteReviewMutationError = VoteReview400 | VoteReview404

    /**
 * @summary 리뷰 투표
 */
export const useVoteReview = <TError = VoteReview400 | VoteReview404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof voteReview>>, TError,{reviewId: string;data: VoteReviewBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationResult<
        Awaited<ReturnType<typeof voteReview>>,
        TError,
        {reviewId: string;data: VoteReviewBody},
        TContext
      > => {

      const mutationOptions = getVoteReviewMutationOptions(options);

      return useMutation(mutationOptions);
    }
    